var user = {};
var bindParams = {};
var config = { account: "", channel: "",  shareId: ""};
var setUserId = '';
var helpId = '';

var testApi = '//tapi.qcplay.com';
var api = "https://api.qingcigame.com"; // 链接
// var api = "https://tapi.qcplay.com"; // 测试链接
var QQurl = 'https://static.qcplay.com/kol/jump_03.html'    // 加入qq群
var quantity = '';
var obj = {
    help: function() {
        this.preloading();  // 预加载
        this.userInfo();    // 获取用户信息
        this.indexBind();   // 绑定
        this.indexSwiper(); // 轮播
        this.share();       // 分享详情
        this.remJs();       // 750尺寸rem
        this.wowAni();      // wow动画
    },
    // 图片资源预加载
    preloading: function() {
        //图片预加载
        var queue = new createjs.LoadQueue();
        queue.on("progress", function(e) {
            //加载中的进度
            if (e.progress * 100 >= 10) {
                $(".loding_time span").width(parseInt(e.progress * 100) + '%')
            };
            var numbers = e.progress * 100;

        }, this);
        queue.on("complete", function(e) {
            //加载完成执行操作
            $('.loding_time').fadeOut();
            setTimeout(function() {
                $('.preloading').addClass('preloading-ani').fadeOut(1000);
                $('.index').addClass('index-show');
                $('.float-nav').addClass('float-nav-ani');
            },400)
            // this.indexSwiper();
        }, this);
        queue.loadManifest([
            //加载图片，不包括后台的
            'images/m_dt_sz.png',
            // 'images/pc/m_dt_t.png',
            // 'images/pc/m_jdt.png',
            // 'images/pc/m_jdt_01.png',
            // 'images/pc/m_jdt_02.png',
            // 'images/pc/preloading_role.png',
            // 'images/pc/start_btn.png',
            // 'images/pc/title_img.png',
            // 'images/pc/label_02_all_img.png',
            // 'images/pc/label_all_img.png',
            // 'images/pc/logo_img.png',
            // 'images/pc/arrow_t.png',
            // 'images/pc/float_label.png',
            // 'images/pc/float_code.png',
            // 'images/pc/label_all.png',
            // 'images/pc/video_btn.png',
            // 'images/pc/content_bg_01.jpg',
            // 'images/pc/logo.png',
            // 'images/pc/arrow_b.png',
            // 'images/pc/media/bg.mp4'
        ]);
    },
    userInfo: function() {
        // 默认初始化参数
        config = { account: "", channel: "",  shareId: ""};

        var index = layer.load(1);
        $.ajax({
            url: api + "/lantern/online/is_wx_login",
            type: "GET",
            xhrFields: { withCredentials: true },
            error: function() {
                layer.msg("请求失败,请联系客服");
            },
            success: function(json) {
                // 初始化用户信息
                var $userInfo = $('.data-userinfo');
                $userInfo.removeClass('account-info');
                var ua = navigator.userAgent.toLowerCase();
                if (ua.toLowerCase().match(/MicroMessenger/i) == "micromessenger" || ua.match(/QQ/i) == "qq") {
                    switch (json.code) {
                        case 302:
                            // 微信|qq都没登录
                            var isWeChatBroswer = ua.match(/MicroMessenger/i) == "micromessenger";
                            window.location.href = json.data[isWeChatBroswer ? 'wechat.url' : 'qq.url'] + '?callback=' + encodeURI(window.location.href);
                            break;
                        case 200:

                            setUserId = user.user_id;                      
                            helpId = window.location.href.split('id=')[1]; 

                            obj.share();

                            // 分享出去看到战队列表
                            obj.ranksShare();

                            break;
                    }
                } else {
                    $('.other-share-popup').show()
                }
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    // 查看当前战队列表
    ranks: function() {
        var index = layer.load(1);
        $.ajax({
            url: api + '/lantern/online/my/help/list',
            type: "GET",
            xhrFields: { withCredentials: true },
            error: function() {
                layer.msg("非常抱歉，请求服务器失败，请重试。");
            },
            success: function(json) {
                if (json.code == 200) {
                    var invitationNumber = json.data.helper_list.length;
                    $('.reach').addClass('reach-0'+invitationNumber+'');

                    console.log(invitationNumber);

                    $.each(json.data.helper_list, function(index, values) {
                        $('.li-img-'+index+' img').remove();
                        $('.li-img-'+index+'').append('<img src="'+values.user_info.avatar+'">');
                    });
                    return;
                }
                layer.msg(json.message);
            },
            complete: function() {
                layer.close(index);
            }
        });
    },
    ranksShare: function() {
        console.log(helpId);
        var index = layer.load(1);
        $.ajax({
            url: api + '/lantern/online/help/list',
            type: "GET",
            xhrFields: { withCredentials: true },
            data: {
                helper_id: helpId
            },
            error: function() {
                layer.msg("非常抱歉，请求服务器失败，请重试。");
            },
            success: function(json) {
                if (json.code == 200) {
                    var invitationNumber = json.data.helper_list.length;
                    $('.reach').addClass('reach-0'+invitationNumber+'');

                    console.log(invitationNumber);

                    $.each(json.data.helper_list, function(index, values) {
                        $('.li-img-'+index+' img').remove();
                        $('.li-img-'+index+'').append('<img src="'+values.user_info.avatar+'">');
                    });
                    return;
                }
                layer.msg(json.message);
            },
            complete: function() {
                layer.close(index);
            }
        });
    },
    serverInfo: function(account) {
        // 初始化打开状态
        $('.tab-server').show();
        $('.tab-server').find('.active').removeClass('active');
        $('.tab-server').find('div:first').addClass('active');
        $('.gzf').addClass('show');
        $('.zsf').removeClass('show');
        $('input[name=gzf_role_name]').val('');
        $('input[name=zsf_role_name]').val('');
        // 初始化参数状态
        bindParams = {}

        var index = layer.load(1);
        $.ajax({
            url: api + '/lantern/server/qcgame',
            type: "GET",
            xhrFields: { withCredentials: true },
            data: {
                account: account
            },
            error: function() {
                layer.msg("非常抱歉，请求服务器失败，请重试。");
            },
            success: function(json) {
                if (json.code != 200) {
                    layer.msg(json.message);
                    return false;
                }
                // 42 先锋服
                // 33 正式服

                var xff = json.data[42]; // 先锋服
                var zsf = json.data[33]; // 正式服

                if (!xff && !zsf) {
                    layer.msg("查无您的角色信息")
                    return
                } else if (!xff || !zsf) {
                    $('.tab-server').hide()
                } else {
                    $('.tab-server').show()
                }

                if (xff) {
                    $('.gzf select').html('<option value="">请选择区组</option>');
                    var list = xff.android;
                    for (var key in list) {
                        var value = list[key];
                        $('.gzf select').append('<option data-uid="' + value['uid'] + '" data-setId="' + value['setId'] + '" data-role-name="' + value['nickname'] + '" data-serverId="' + value['serverId'] + '">' + value['setId'] + '区服'+'</option>')
                    }

                    $('.gzf select').off('change').on('change', function() {
                        var option = $(this).find('option:selected');
                        if (option.val()) {
                            // 改值
                            $('input[name=gzf_role_name]').val($(this).find('option:selected').attr('data-role-name'));
                            bindParams = {
                                game_id: 42,
                                uid: option.attr('data-uid'),
                                role_name: option.attr('data-role-name'),
                                serverId: option.attr('data-serverId'),
                                setId: option.attr('data-setId'),
                                type: "android"
                            }
                        } else {
                            // 清空
                            $('input[name=gzf_role_name]').val('');
                            bindParams = {}
                        }

                    })

                } else {
                    $('.gzf').removeClass('show')
                }

                if (zsf) {
                    // 如果没有光子服就显示
                    xff ? $('.zsf').removeClass('show') : $('.zsf').addClass('show');

                    // 初始化内容
                    $('.zsf-os').html('<option value="">请选择手机系统</option>')
                    $('.zsf-server').html('<option value="">请选择区服</option>')

                    // 拼接手机系统
                    for (var key in zsf) {
                        $('.zsf-os').append('<option value="' + key + '">' + key + '</option>')
                    }

                    // 手机系统选择
                    $('.zsf-os').off('change').on('change', function() {

                        bindParams = { game_id: 33, type: $(this).val() }

                        var role = zsf[$(this).val()];
                        // 区服下拉框设置为空
                        $('.zsf-server').html('<option value="">请选择区服</option>');
                        // 角色信息为空
                        $('.zsf-role').val('');
                        // 拼接区服下拉框
                        for (var key in role) {
                            var value = role[key];
                            $('.zsf-server').append('<option data-uid="' + value['uid'] + '" data-setId="' + value['setId'] + '" data-role-name="' + value['nickname'] + '" data-serverId="' + value['serverId'] + '">' + value['setId'] + '区服'+'</option>')
                        }

                        // 响应区服下拉框事件
                        $('.zsf-server').on('change', function() {
                            var option = $(this).find('option:selected');
                            if (option.val()) {
                                $('.zsf-role').val(option.attr('data-role-name'))
                                bindParams.uid = option.attr('data-uid')
                                bindParams.role_name = option.attr('data-role-name')
                                bindParams.serverId = option.attr('data-serverId')
                                bindParams.setId = option.attr('data-setId')
                            } else {
                                $('.zsf-role').val('');
                                bindParams = { game_id: 33, type: $(this).val() }
                            }
                        });
                    })
                } else {
                    $('.zsf').removeClass('show')
                }


                $('.inp-account').val(''); // 账号密码清空
                $('.inp-password').val(''); // 账号密码清空
                $('.register-popup').fadeOut(); // 关闭登陆页面
                $('.server-popup').fadeIn(); // 开启服务器
                openA();

            },
            complete: function() {
                layer.close(index)
            }
        })

        function openA() {
            setTimeout(function() {
                $('.popup_box').addClass('ani');
            }, 200);
        }
    },
    share: function(id) {
        $.ajax({
            url: api + "/wechat/jssdk",
            type: "POST",
            data: {
                uri: window.location.href
            },
            success: function(json) {
                // 此刻分享的页面
                var today = new Date()
                var year = today.getFullYear();
                var month = today.getMonth() + 1;
                month = month < 10 ? "0" + month : month;
                var day = today.getDate();
                day = day < 10 ? "0" + day : day;
                var hour = today.getHours();
                hour = hour < 10 ? "0" + hour : hour;
                var minute = today.getMinutes()
                minute = parseInt(minute / 10) * 10;
                minute = minute < 10 ? "00" : minute;

                var file = "https://tideng.qingcigame.com/online/" + year + "" + month + "" + day + "" + hour + "" + minute + ".html?id="+setUserId
                // var file = "https://tideng.qingcigame.com/online/help.html?id="+setUserId
                var ua = navigator.userAgent.toLowerCase();
                if (ua.match(/MicroMessenger/i) == "micromessenger") {
                    wx.config(json.data);
                    wx.ready(function() {
                        
                        wx.updateAppMessageShareData({
                            title: '萌宠派遣，深渊探索', // 分享标题
                            desc: '快来邀请好友加入派遣队，赢道具福利！', // 分享描述
                            link: file, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl: 'https://static.qcplay.com/common/td_share_img_01.png', // 分享图标
                            success: function() {
                                // obj.addShare();
                            }
                        })

                        wx.updateTimelineShareData({
                            title: '萌宠派遣，深渊探索', // 分享标题
                            link: file, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl: 'https://static.qcplay.com/common/td_share_img_01.png', // 分享图标
                            success: function() {
                                // obj.addShare();
                            }
                        })
                    });
                    return;
                } else {
                    setShareInfo({
                        title: '萌宠派遣，深渊探索', // 分享标题
                        summary: '快来邀请好友加入派遣队，赢道具福利！', // 分享内容
                        pic: 'https://static.qcplay.com/common/td_share_img_01.png', // 分享图片
                        url: file, // 分享链接
                        // 微信权限验证配置信息，若不在微信传播，可忽略
                        WXconfig: {
                            appId: json.data.appId, // 公众号的唯一标识
                            timestamp: json.data.timestamp, // 生成签名的时间戳
                            nonceStr: json.data.nonceStr, // 生成签名的随机串
                            signature: json.data.signature // 签名
                        }
                    });
                }
            }
        })
    },
    // 绑定
    indexBind: function() {

        // 点击加入队伍
        $('.invite-btn').click(function(event) {
            layer.msg("很抱歉，活动已结束");
            // var index = layer.load(1);
            // $.ajax({
            //     url: api + '/lantern/online/help',
            //     type: "POST",
            //     xhrFields: { withCredentials: true },
            //     data: {
            //         helper_id: helpId
            //     },
            //     error: function() {
            //         layer.msg("非常抱歉，请求服务器失败，请重试。");
            //     },
            //     success: function(json) {
            //         // 此刻分享的页面
            //         var today = new Date()
            //         var year = today.getFullYear();
            //         var month = today.getMonth() + 1;
            //         month = month < 10 ? "0" + month : month;
            //         var day = today.getDate();
            //         day = day < 10 ? "0" + day : day;
            //         var hour = today.getHours();
            //         hour = hour < 10 ? "0" + hour : hour;
            //         var minute = today.getMinutes()
            //         minute = parseInt(minute / 10) * 10;
            //         minute = minute < 10 ? "00" : minute;
            //         var file = "https://tideng.qingcigame.com/online/" + year + "" + month + "" + day + "" + hour + "" + minute + ".html"
                        
            //         $('.join-wrap a').attr('href', file);
            //         $('.join-wrap-3 a').attr('href', file);

            //         // 302 去授权
            //         // 401 很抱歉，您的好友还未绑定游戏信息
            //         // 402 很抱歉，您已经在好友的队伍里面
            //         // 403 很抱歉，您不能加入自己的队列
            //         // 405 很抱歉，您的好友队伍已经满员
            //         if (json.code == 302) {
            //             obj.userInfo();
            //             return;
            //         }
            //         if (json.code == 402) {
            //             $('.join-wrap').fadeIn();
            //             openA();
            //             return;
            //         }
            //         if (json.code == 401) {
                        
            //             window.location.href = file;
            //             return;
            //         }
            //         if (json.code == 403) {
            //             layer.msg(json.message);
            //             return;
            //         }
            //         if (json.code == 405) {
            //             $('.join-wrap-3').fadeIn();
            //             openA();
            //             return;
            //         }
            //         if (json.code == 200) {
            //             $('.join-wrap').fadeIn();
            //             openA();
            //             obj.ranksShare();
            //             return;
            //         }
            //     },
            //     complete: function() {
            //         layer.close(index);
            //     }
            // });
        });

        // 关闭视频弹窗
        var Media = document.getElementById('media-play');
        $('.video-wrap').on('click', '.close-btn', function(event) {
            Media.pause();
            close();
        });

        // 视频开启，直接播放
        $('.video-btn').on('click', function(event) {
            var video_url = 'https://www.bilibili.com/video/BV1FK4y1D7xC/';
            window.location.href = video_url;
            // Media.play();
            // $('.video-wrap').fadeIn();
            // openA();
        });

        // 第三方页面跳转
        $('.link-a').click(function(event) {
            var _this = $(this).attr('data');
            window.location.replace(_this);
        });

        // 点击弹窗背景关闭弹窗
        $('.close-bg').click(function(event) {
            $('.popup').fadeOut();
        });

        // 点击分享按钮
        $('.share-btn').on('click', function(event) {
            $('.share-wrap').fadeIn();
        });

        // 关闭分享提示
        $('.share-wrap').on('click', function() {
            $(this).fadeOut();
        });

        // 关闭动画
        function close() {
            $('.popup_wrap').fadeOut().find('.popup_box').removeClass('ani');
        }

        // 点击关闭弹窗
        $('.close-bg, .close-btn').click(function(event) {
            close();
        });

        // 开启动画
        function openA() {
            setTimeout(function() {
                if (!!window.ActiveXObject || "ActiveXObject" in window) {
                    $('.popup_box').addClass('ani-ie');
                } else {
                    $('.popup_box').addClass('ani');
                }
            }, 200);
            setTimeout(function() {
                $('.close').addClass('closeAni')
            }, 300);
        }

        // 关闭动画
        function close() {
            $('.popup_wrap').fadeOut().find('.popup_box').removeClass('ani');
        }
    },
    indexSwiper: function() {
        var mySwiper2 = new Swiper('.swiper-container2', {
            loop: true,
            effect: 'coverflow',
            centeredSlides: true,
            nextButton: '.next',
            prevButton: '.prev',
            slidesPerView: 'auto',
            autoplay: 2000,
            observer:true,
            observeParents:true,
            pagination: '.swiper-pagination',
        });
    },
    // 获取当前hash的具体参数
    getQueryVariable: function(variable) {
        var query = window.location.href.split('?')[1];
        var vars = query.split("&");
        for (var i=0;i<vars.length;i++) {
            var pair = vars[i].split("=");
                if(pair[0] == variable){return pair[1];}
            }
        return(false);
    },
    remJs: function() {
        $(function(){function t(){var t=$("html").width();750<=t?$("html").css({"font-size":"40px"}):$("html").css({"font-size":40/750*t+"px"})}$(window).resize(t),t()});
    },
    wowAni: function() {
        var wow = new WOW({ 
            boxClass: 'wow', 
            animateClass: 'animated', 
            offset: 0, 
            mobile: true, 
            live: true 
            }); 
        wow.init();
    },
}